export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 42 32" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-694.000000, -9709.000000)">
                    <g id="编组-33" transform="translate(0.000000, 6400.000000)">
                        <g id="编组-26" transform="translate(400.000000, 2927.000000)">
                            <g id="编组-24" transform="translate(0.000000, 381.000000)">
                                <g id="Time-Saving" transform="translate(294.000000, 1.000000)">
                                    <rect id="矩形" fillOpacity="0" fill="#000000" x="0" y="0" width="42" height="32"></rect>
                                    <g id="编组-22" transform="translate(0.000000, 1.000000)" stroke="#000000" strokeWidth="2.08">
                                        <circle id="椭圆形" cx="15.5" cy="15.5" r="14.46"></circle>
                                        <path
                                            d="M18.5952724,7 C18.5952724,14.459422 18.5952724,18.189133 18.5952724,18.189133 C18.5952724,18.189133 16.3968483,18.189133 12,18.189133"
                                            id="路径-10"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
